import axios from "@/utils/axiosHelper";

// 初始化
export const onInitAPI = params => {
  return axios(
    { url: "/game/collect/init", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 领取彩蛋
export const onEggRewardAPI = params => {
  return axios(
    { url: "/game/collect/store", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 做任务记录
export const onGetShareReward = params => {
  return axios(
    { url: "/game/collect/task/store", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 点击领取获取碎片
export const onGetRewardFragment = params => {
  return axios(
    { url: "/game/collect/task/update", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 注销
export const onLogoutAPI = params => {
  return axios(
    { url: "/game/my/disable", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 生成分享链接参数
export const getShareCode = params => {
  return axios(
    { url: "/game/collect/code", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 分享链接初始化
export const initShareLink = params => {
  return axios(
    { url: "/game/collect/help", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 领取集成碎片奖励及合成奖励
export const getFragmentReward = params => {
  return axios(
    { url: "/game/collect/reward", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 领取其他人分享的碎片
export const getOtherFragment = params => {
  return axios(
    { url: "/game/collect/card", method: "POST", params },
    { interceptResultCode: false }
  );
};


// WEBPACK FOOTER //
// ./src/pages/tideng/year/api.js